import { createFileRoute } from '@tanstack/react-router';
import { ServerErrorPage } from '@/pages/errors/ui/ServerErrorPage';

/**
 * 500 Internal Server Error ルート定義
 *
 * App層の責務:
 * - URLパス `/500` を ServerErrorPage にマッピング
 * - サーバーエラー時の表示
 * - TanStack Router のファイルベースルーティング
 */
export const Route = createFileRoute('/500')({
  component: ServerErrorPage,
});
